module.exports = __webpack_public_path__ + "img/1558345338.86d36839.jpg";